import type { LoaderFunction, LoaderFunctionArgs } from 'react-router-dom';
import { loader } from "../pages/Wrestler";

// Funzione per rilevare se siamo in modalita mobile senza hook
const isMobileScreen = (): boolean => {
    if (typeof window === 'undefined') {
        return false; // Server-side rendering fallback
    }
    return window.innerWidth < 768;
};

export const WrestlerResponsiveLoader: LoaderFunction = async ({ request, params }: LoaderFunctionArgs) => {
    // I parametri vengono passati direttamente dal router
    const isMobile = isMobileScreen();
    if (isMobile) {
        return null;
    } else {
        return loader({ request, params });
    }
};
